import React from 'react';
import PropTypes from 'prop-types';

import UpdateAnnotationMaps from './UpdateAnnotationMaps';
import CreateAnnotationMaps from './CreateAnnotations/CreateAnnotationMaps';

const AnnotationMapsEditor = props => {
  const {
    annotations,
    annotationTemplates,
    handleCloseEdit,
    handleCloseUpdateEditor,
    handleNewAnnotationId,
    handleAnnotationDeleted,
    handleAnnotationUpdated,
    isUpdateEditor,
    selectedAnnotation,
    sizePlayer,
    timeVideoDuration,
    videoSelected
  } = props;

  return (
    <>
      {!isUpdateEditor ? (
        <CreateAnnotationMaps
          annotations={annotations}
          annotationTemplates={annotationTemplates}
          handleCloseEdit={handleCloseEdit}
          handleNewAnnotationId={handleNewAnnotationId}
          sizePlayer={sizePlayer}
          timeVideoDuration={timeVideoDuration}
          videoSelected={videoSelected}
          selectedAnnotation={selectedAnnotation}
        />
      ) : (
        <UpdateAnnotationMaps
          handleCloseUpdateEditor={handleCloseUpdateEditor}
          selectedAnnotation={selectedAnnotation}
          handleAnnotationDeleted={handleAnnotationDeleted}
          handleAnnotationUpdated={handleAnnotationUpdated}
        />
      )}
    </>
  );
};

AnnotationMapsEditor.defaultProps = {};

AnnotationMapsEditor.propTypes = {
  annotations: PropTypes.array.isRequired,
  annotationTemplates: PropTypes.array.isRequired,
  handleCloseEdit: PropTypes.func.isRequired,
  handleCloseUpdateEditor: PropTypes.func.isRequired,
  handleNewAnnotationId: PropTypes.func.isRequired,
  isUpdateEditor: PropTypes.bool.isRequired,
  selectedAnnotation: PropTypes.object.isRequired,
  sizePlayer: PropTypes.object.isRequired,
  timeVideoDuration: PropTypes.number.isRequired,
  videoSelected: PropTypes.object.isRequired,
  handleAnnotationDeleted: PropTypes.func.isRequired,
  handleAnnotationUpdated: PropTypes.func.isRequired
};

export default AnnotationMapsEditor;
